module.exports = __webpack_public_path__ + "img/6.bd3f1a45.png";